import {
  EfsMelcoEfsModelsMappingFileAttribute,
  EfsMelcoEfsModelsSchemaListItem,
  ProductionFulfillmentApi,
  useAuthenticatedAPIConfig,
  useFormSubmit,
} from "melco-shared-logic";

export type InputFormatDetailFormValueType = {
  id: string;
  key: string;
  display_name: string;
  xml_orders_xpath?: string;
  unique_field?: string;
  headers?: boolean;
  type?: string;
  schema_list?: EfsMelcoEfsModelsSchemaListItem[];
  filename_rules_list?: EfsMelcoEfsModelsMappingFileAttribute[];
};

export const useInputFormatFormSubmit = () => {
  const authenticatedApiConfig = useAuthenticatedAPIConfig();

  const onSubmit = useFormSubmit<InputFormatDetailFormValueType>(
    async (values: InputFormatDetailFormValueType, { resetForm }) => {
      const {
        id,
        key,
        display_name,
        xml_orders_xpath,
        unique_field,
        headers,
        type,
        schema_list,
        filename_rules_list,
      } = values;

      const api = new ProductionFulfillmentApi(authenticatedApiConfig());

      await api.productionFulfillmentFormatsEdit({
        id,
        efsMelcoEfsModelsCreateFormat: {
          key,
          display_name,
          xml_orders_xpath,
          unique_field,
          headers,
          type,
          schema_list,
          filename_rules_list,
        },
      });

      resetForm({ values });

      return { successMessages: [{ message: "default" }] };
    },
    { translationPrefix: "inputFormats.detail.save" }
  );

  return onSubmit;
};
